import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Header from "../../components/header";
import Footer from "../../components/footer";
import "./page.scss";

const Page = ({ children, className }) => (
  <div className={cn("page", className)}>
    <Header />
    <div className="page__content">{children}</div>
    <Footer />
  </div>
);

Page.propTypes = {
  children: PropTypes.node
};

export default Page;
